/* ***************************************
This mixin "exposes" the data item...
  * googleAnalyticsId [for LoginLogout, NikudEdit, TextPrep, and UserSettings]
... and the method:
  * gtag() [for the above 4 + DocumentSettings, "headers", ManualNikudPane, NikudOptionsPane, & NikudResultsContainer]
(all else should be considered "internal")
*************************************** */

window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}

export default {
  name: 'serviceMixins',
  data () {
    return {
      googleAnalyticsId: 'UA-103843509-12' // like in "/public/index.html" header
    }
  },
  methods: {
    gtag: gtag
  }
}